import { Bleed, Paragraph, H3, Card, Image, Separator, Row, Ellipsis, colors } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { ContentLock, ContentUnlock } from '@fs/zion-icon'
import { getCustomImage, getRelativePath } from '../../../helpers'
import { StrongLink } from '../../../link'
import SafeRichText from '../../../SafeRichText'
import { DraftBadge, LanguageBadge, PublishedBadge, SubmittedBadge } from '../../../Badge'
import { MonoText } from '../../../type'

const cardHackCss = css`
  position: relative;
  & > :nth-of-type(n) {
    --roundiness: 20em;
  }
`
const cardFooterCss = css`
  position: absolute;
  bottom: 0;
  width: 100%;
`

export default function SpeakerCard({
  title,
  description,
  url,
  locale,
  badge,
  placeholder,
  lockedState,
  dataTestId,
  ...speaker
}) {
  const [t] = useTranslation()
  const LockedIcon = lockedState === 'lock' ? ContentLock : ContentUnlock
  const to = getRelativePath(url)

  return (
    <div data-testid={dataTestId || 'speaker-card'}>
      <div css={cardHackCss}>
        <Card to={to}>
          <Bleed all>
            <Image
              src={getCustomImage(speaker, placeholder)}
              alt={`${t('speaker.card.image.alt.title', 'Profile image for')} ${title}`}
              style={{ aspectRatio: '1 / 1' }}
            />
          </Bleed>
        </Card>
        <div css={cardFooterCss}>
          <Row guttersY="none" alignY="middle">
            <LanguageBadge contentLocale={locale} />
            <div growX />
            {lockedState && <LockedIcon background={colors.gray02} color={colors.gray100} size="sm" />}
          </Row>
        </div>
      </div>

      <Separator size="xxs" />
      {badge && ['SUBMITTED', 'DRAFT', 'PUBLISHED', 'WORKFLOW'].includes(badge) && (
        <>
          <Row alignX="center" guttersY="none">
            {badge === 'DRAFT' && <DraftBadge />}
            {(badge === 'SUBMITTED' || badge === 'WORKFLOW') && <SubmittedBadge />}
            {badge === 'PUBLISHED' && <PublishedBadge />}
          </Row>
          <Separator size="xxs" />
        </>
      )}

      <Row alignX="center" guttersY="none">
        <MonoText>
          <H3 size="H6" centered data-testid="card-header">
            <StrongLink noUnderline to={to}>
              {title}
            </StrongLink>
          </H3>
        </MonoText>
      </Row>
      <Paragraph centered size="sm">
        <span style={{ color: colors.gray80 }}>
          <Ellipsis lineClamp={3} noTooltip>
            <SafeRichText as="span" dirtyInput={description} />
          </Ellipsis>
        </span>
      </Paragraph>
    </div>
  )
}
